import { getFetch } from '../fetch';
import { apiConfig } from '../config';
// @ts-ignore
import type { SUBJECTS_SLUGS } from '../../../constants';

/** Получить слаги предметов открытых учительских курсов */
export function getCoursesSubjects(): Promise<SUBJECTS_SLUGS[]> {
    const { apiGetCoursesSubjects } = apiConfig.getStaticUrls();

    return getFetch(apiGetCoursesSubjects);
}
